import EnableCookiesPage from './pages/EnableCookiesPage';

interface CheckCookiesEnabledProps {
    children: React.ReactNode;
}

function CheckCookiesEnabled(props: CheckCookiesEnabledProps) {
    const { children } = props;

    return navigator?.cookieEnabled ? children : <EnableCookiesPage />;
}

export default CheckCookiesEnabled;
